<template>
  <Content @back="back" :noBack="['expert','organ'].includes(userRole)">
    <template v-slot:nav_left>
      <div class="nav_wrap">
        <div class="nav_list">
          <div class="nav_item" @click="jumpTo('/talentSendPlayer/list')">
            人才输送
          </div>
          <div
              v-for="(nav, index) in navTitle"
              :key="index"
              :class="idx === index ? 'active' : ''"
              @click="changeNav(index)"
              class="nav_item">
            {{ nav }}
          </div>
        </div>
      </div>
    </template>
    <template v-slot:nav_right>
      <template v-if="userRole === 'system'">
        <div v-if="idx === 1" class="yioks_btn" @click="AddRecordDialog">添加集训</div>
        <div v-else class="yioks_btn" @click="AddRecordDialog">添加比赛</div>
      </template>
      <template v-if="userRole === 'admin' || userRole === 'system' ||  userRole === 'expert'">
        <div class="yioks_btn" @click="recordSumAuditRanking">排行榜</div>
      </template>
    </template>
    <template v-slot:content_right>
      <div class="select_wrap">
        <div class="select_box">
          <select
            v-model="selectVal.recordYear"
            class="yioks_select"
            @change="changeQuery(true)"
          >
            <option
              v-for="(item, index) in yearList"
              :key="index"
              :value="item.value"
            >
              {{ item.value }}
            </option>
          </select>
        </div>
        <div class="search_box">
          <input
              v-model.trim="selectVal.keyWord"
              type="text"
              class="yioks_input"
              placeholder="请输入关键词"
              @keyup.enter="changeQuery(true)"
          >
          <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
        </div>
      </div>

      <div class="list_wrap">
        <div v-if="showList" class="table">
          <template v-if="userRole === 'youth' || userRole === 'trainCamp' || userRole === 'club'">
            <div v-if="idx === 1"
                 style="position: absolute;margin-left: 40px;margin-top: -20px;font-weight: bold;color: red;">
              <span>如果本机构球员被录取参加如下高水平集训，请提交相关信息进行审核确认。</span>
            </div>
            <div v-else style="position: absolute;margin-left: 40px;margin-top: -20px;font-weight: bold;color: red;">
              <span>如果本机构球队参加如下市级以上高水平足球赛事并获得优秀成绩，请提交相关信息进行审核确认。</span>
            </div>
          </template>
          <template v-else>
            <div v-if="idx === 1"
                 style="position: absolute;margin-left: 40px;margin-top: -20px;font-weight: bold;color: red;">
              <span>机构球员被录取参加如下高水平集训，请进行审核确认（系统将自动审核通过数据库匹配成绩）</span>
            </div>
            <div v-else style="position: absolute;margin-left: 40px;margin-top: -20px;font-weight: bold;color: red;">
              <span>机构球队参加如下市级以上高水平足球赛事并获得优秀成绩，请进行审核确认（系统将自动审核通过数据库匹配成绩）</span>
            </div>
          </template>
          <div class="thead">
            <div class="tr">
              <div class="th seq"><strong>序号</strong></div>
              <div v-if="idx === 1" class="th"
                   :class="userRole === 'youth' || userRole === 'trainCamp' || userRole === 'club' ? 'recordName1' : 'recordName'">
                <strong>集训名称</strong>
              </div>
              <div v-else class="th recordName">
                <strong>被认定高水平赛事名称</strong>
              </div>
              <template v-if="idx === 1 && (userRole === 'youth' || userRole === 'trainCamp' || userRole === 'club')">
                <div class="th auditState"><strong>审核状态</strong></div>
                <div class="th submitNum1"><strong>提交球员总数</strong></div>
              </template>
              <template v-else>
                <div class="th auditSucceedNum"><strong>审核通过</strong></div>
                <div class="th auditRejectNum"><strong>审核不通过</strong></div>
                <div class="th auditReturnNum"><strong>审核驳回</strong></div>
                <div class="th auditAwaitNum"><strong>待审核</strong></div>
                <div class="th submitNum"><strong>提交总数</strong></div>
              </template>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll>
              <div class="tbodyWrap">
                <div class="tbody">
                  <div
                      v-for="(item, index) in recordList"
                      :key="index"
                      class="tr" style="height: 70px">
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <div class="td"
                         :class="idx === 1 && (userRole === 'youth' || userRole === 'trainCamp' || userRole === 'club') ? 'recordName1' : 'recordName'"
                         :title="item.recordName" style="justify-content: flex-start;">
                      <p style="white-space: break-spaces;">{{ item.recordName || '--' }}</p>
                    </div>
                    <template v-if="idx === 1 && (userRole === 'youth' || userRole === 'trainCamp' || userRole === 'club')">
                      <template v-if="item.submitNum">
                        <div class="td auditState">
                          <p>{{ item.auditState | auditState }}</p>
                        </div>
                      </template>
                      <template v-else>
                        <div class="td auditState">
                          <p>--</p>
                        </div>
                      </template>
                      <div class="td submitNum1">
                        <p>{{ item.submitNum || '--' }}</p>
                      </div>
                    </template>
                    <template v-else>
                      <div class="td auditSucceedNum">
                        <p>{{ item.auditSucceedNum || '--' }}</p>
                      </div>
                      <div class="td auditRejectNum">
                        <p>{{ item.auditRejectNum || '--' }}</p>
                      </div>
                      <div class="td auditReturnNum">
                        <p>{{ item.auditReturnNum || '--' }}</p>
                      </div>
                      <div class="td auditAwaitNum">
                        <p>{{ item.auditAwaitNum || '--' }}</p>
                      </div>
                      <div class="td submitNum">
                        <p>{{ item.submitNum || '--' }}</p>
                      </div>
                    </template>
                    <div class="td opt">
                      <p>
                        <template v-if="userRole === 'system' || userRole === 'admin' ||  userRole === 'expert' || userRole === 'organ' ">
                          <template v-if="item.auditAwaitNum">
                            <span class="item" @click="goAuditList(item.uuid)">审核</span>
                          </template>
                          <template v-else>
                            <span class="item" @click="goAuditList(item.uuid)">查看</span>
                          </template>

                          <template v-if="userRole === 'system'">
                            <span class="split">/</span>
                            <span class="item" @click="editRecord(item.uuid)">编辑</span>
                            <span class="split">/</span>
                            <span class="item" @click="deleteRecord(item.uuid)">删除</span>
                          </template>
                        </template>
                        <template v-else>
                          <template v-if="item.auditState === 0 || item.auditState === 2">
                            <span class="item" @click="goYouthList(item.uuid)">提交</span>
                          </template>
                          <template v-else>
                            <span class="item" @click="goYouthList(item.uuid)">查看</span>
                          </template>
                        </template>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading"/>
        <template v-if="userRole === 'system'">
          <yioks-empty v-if="empty" tips="暂时没有数据，" name="立即添加数据" @callback="AddRecordDialog"></yioks-empty>
        </template>
        <template v-else>
          <yioks-empty v-if="empty" tips="暂时没有数据"></yioks-empty>
        </template>
      </div>
      <Pagination :total="total" :page.sync="page"/>
      <yioks-tip :showTip="showTip" :tipMsg=" idx === 1 ? '确定删除该集训吗？' : '确定删除该比赛吗？'"
                 @callback='isDelete'/>
      <template v-if="addRecord">
        <AddRecordDialog
            :isShowDialog="addRecord"
            :isEdit="isEdit"
            :recordUuid="recordUuid"
            :recordType="recordType"
            @hideAddRecordDialog="hideAddRecordDialog"></AddRecordDialog>
      </template>
      <template v-if="addRanking">
        <RankingDialog
            :isShowRankingDialog="addRanking"
            :recordType="recordType"
            :title="title"
            @hideRankingDialog="hideRankingDialog">
        </RankingDialog>
      </template>
      <template v-if="addSumRanking">
        <SumRankingDialog
            :isShowSumRankingDialog="addSumRanking"
            @hideSumRankingDialog="hideSumRankingDialog">
        </SumRankingDialog>
      </template>
    </template>

  </Content>
</template>

<script>

import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/regular/trash-alt'
import 'vue-awesome/icons/regular/edit'
import record from '@/api/record'
import storage from '@/utils/storage'
import squadFormRule from '@/utils/formRules/squad'
import {ops} from '@/utils/scrollIndialog'

export default {
  components: {
    'Content': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination'),
    'AddRecordDialog': () => import('@/components/record'),
    'RankingDialog': () => import('@/components/record/recordRankingList'),
    'SumRankingDialog': () => import('@/components/record/recordSumRankingList'),
  },
  mixins: [squadFormRule],
  data() {
    return {
      ops,
      recordList: [],
      addRecord: false,
      addRanking: false,
      addSumRanking: false,
      recordType: '',
      title: '',
      isEdit: false,
      navTitle: ['参赛成绩(高水平赛事)','集训营'],
      userRole: storage.get('userInfo').userRole,
      uuid: storage.get('userInfo').uuid,
      idx: Number(this.$route.query.idx) || 0,
      recordUuid: '',
      total: 0,
      pageSize: 20,
      page: 0,
      empty: false,
      showList: false,
      showTip: false,
      loading: true,
      selectVal: {
        keyWord: '',
        recordYear:'',
        youthUuid: "",
        organUuid: "",
      },
    }
  },
  watch: {
    page() {
      this.changeQuery()
    }
  },

  filters: {
    auditState(val) {
      let res = '';
      switch (val) {
        case 0:
          res = '待审核';
          break;
        case 1:
          res = '通过';
          break;
        case 2:
          res = '驳回';
          break;
        case 3:
          res = '拒绝';
          break;
        default:
          res = '--';
          break;
      }
      return res;
    },
  },

  created() {
    const {page, keyWord,recordYear, organUuid, youthUuid} = this.$route.query
    page && (this.page = Number(page))
    keyWord && (this.$set(this.selectVal, 'keyWord', keyWord))
    organUuid && this.$set(this.selectVal, "organUuid", organUuid);
    youthUuid && this.$set(this.selectVal, "youthUuid", youthUuid);
    if(recordYear){
      this.$set(this.selectVal, 'recordYear', recordYear)
    }else{
      this.$set(this.selectVal, 'recordYear', new Date().getFullYear())
    }
    this.getRecordList()
  },
  computed:{
    yearList() {
      let year = new Date().getFullYear()
      let yearList = []
      for (var i = 0; i <= (year - 2022); i++) {
        yearList.push({value: (2022 + i), label: (2022 + i)})
      }
      return yearList
    }
  },
  methods: {
    back(){
      if ( this.userRole === "expert" || this.userRole === "organ"){
        this.$router.go(-1)
      }else if ( this.userRole === "admin"){
        this.$router.push('/home/index?details=mans')
      }else {
        this.$router.push('/home')
      }
    },
    jumpTo(path) {
      if(this.userRole === 'expert' || this.userRole === 'organ'){
        this.$router.replace({
          path: path,
          query: {
            organUuid: this.selectVal.organUuid,
            youthUuid: this.selectVal.youthUuid,
          }
        })
      }else{
        this.$router.push(path)
      }
    },
    changeNav(index) {
      if (index === this.idx) return;
      this.idx = index;
      this.changeQuery(false);
    },
    // 添加编辑比赛/集训记录
    AddRecordDialog() {
      this.addRecord = true;
      if (this.idx === 1) {
        this.recordType = "trainCamp"
      } else {
        this.recordType = "match"
      }
    },
    getRecordList() {
      this.loading = true
      this.empty = false
      this.showList = false
      let request = record.recordListSystem
      let recordType
      if (this.idx === 1) {
        recordType = "trainCamp"
      } else {
        recordType = "match"
      }
      request({
        page: this.page,
        size: this.pageSize,
        recordName: this.selectVal.keyWord,
        recordYear: this.selectVal.recordYear,
        recordType: recordType
      }).then((res) => {
        this.loading = false
        this.total = res.totalElements
        if (res.content.length) {
          this.recordList = res.content
          this.showList = true
        } else {
          this.empty = true
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    editRecord(uuid) {
      this.recordUuid = uuid
      this.addRecord = true
      this.isEdit = true
      if (this.idx === 1) {
        this.recordType = "trainCamp"
      } else {
        this.recordType = "match"
      }
    },
    deleteRecord(uuid) {
      this.showTip = true
      this.recordUuid = uuid
    },
    isDelete(isSure) {
      if (isSure) {
        record.deleteRecord(this.recordUuid).then(res => {
          this.showTip = false
          this.getRecordList()
        })
      } else {
        this.showTip = false
      }
    },
    goDetail(uuid) {
      this.$router.push({
        path: 'recordDetail',
        query: {
          uuid
        }
      })
    },
    goYouthList(uuid) {
      if (this.idx === 1) {
        this.$router.push({
          path: 'youthPlayerList',
          query: {
            uuid,
          }
        })
      } else {
        this.$router.push({
          path: 'youthList',
          query: {
            uuid,
          }
        })
      }
    },
    goAuditList(uuid) {
      if (this.idx === 1) {
        this.$router.push({
          path: 'auditYouthPlayerList',
          query: {
            uuid,
            organUuid: this.selectVal.organUuid,
            youthUuid: this.selectVal.youthUuid,
          }
        })
      } else {
        this.$router.push({
          path: 'youthList',
          query: {
            uuid,
            organUuid: this.selectVal.organUuid,
            youthUuid: this.selectVal.youthUuid,
          }
        })
      }
    },
    hideAddRecordDialog(flag) {
      this.isEdit = false
      this.addRecord = flag
      this.getRecordList()
    },

    // 排行榜的回调
    hideRankingDialog(flag,bool) {
      this.addRanking = bool
    },
    // 排行榜的
    recordAuditRanking() {
      this.addRanking = true;
      if (this.idx === 1) {
        this.recordType = "trainCamp";
        this.title = "集训营排行榜";
      } else {
        this.recordType = "match";
        this.title = "高水平赛事排行榜";
      }
    },

    // 总排行榜的回调
    hideSumRankingDialog(flag,bool) {
      this.addSumRanking = bool
    },
    // 总排行榜的
    recordSumAuditRanking() {
      this.addSumRanking = true;
    },
    changeQuery(flag) {
      if (flag) this.page = 0
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          keyWord: this.selectVal.keyWord,
          recordYear: this.selectVal.recordYear,
          organUuid: this.selectVal.organUuid,
          youthUuid: this.selectVal.youthUuid,
          idx: this.idx
        }
      })
      this.getRecordList()
    },
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.list_wrap
  flex 1
  overflow hidden

  .table {
    display flex
    flex-direction column
    flex 1
    width: 100%;

    .thead, .tbody {
      border: 1px solid $color_white;
    }

    .thead {
      margin: 0 40px;

      .tr {
        height: 45px;
        display: flex;
      }
    }

    .scrollArea {
      height: 425px;
      padding-bottom 15px
      /*flex 1 */
      /*overflow hidden*/
    }

    .tbodyWrap {
      display block
      // padding: 0 40px;
    }

    .tbody {
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width: 810px;
      border-top: none;
      border-bottom: none;

      .tr {
        height: 49px;
        display: flex;
        border-bottom: 1px solid $color_white;
      }
    }

    .th, .td {
      height: 100%;
      /*flex: 1 1 auto;*/
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: $font_size_medium;
      border-right: 1px solid $color_white;
    }

    .th:last-child, .td:last-child {
      border-right: none;
    }

    .td {
      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: $color_white;
      }
    }

    .seq {
      width 7%
    }

    .recordName {
      width 27%
    }

    .recordName1 {
      width 42%
    }

    .auditState {
      width 21%
    }

    .auditSucceedNum {
      width 10%
    }

    .auditRejectNum {
      width 12%
    }

    .auditReturnNum {
      width 10%
    }

    .auditAwaitNum {
      width 10%
    }

    .submitNum {
      width: 10%;
    }

    .submitNum1 {
      width: 21%;
    }

    .opt {
      width: 16%;

      p {
        width 100%
        text-align center

        .item {
          cursor: pointer;
          user-select: none;
          color $green_color
        }

        .split {
          margin 0 5px
        }
      }
    }
  }

.demo-ruleForm
  height 475px

.tip
  margin-top 10px
  color red
  width 100%
  text-align center
  word-break break-word

.nav_wrap {
  display: flex;
  justify-content: space-between;
  font-size: 16px;

  .nav_list {
    display: flex;

    .nav_item {
      cursor: pointer;
      user-select: none;
      padding: 10px 15px;

      &.active {
        background: $green_color;
      }
    }
  }
}
</style>

